export const prepareDialog = (d) => {
  const dialog = { ...d };
  if (dialog.prepared) {
    return dialog;
  }
  dialog.enums = dialog.options;
  dialog.units = dialog.stepUnits;

  if (dialog.dataType === "Number") {
    dialog.number = dialog.value ? Number(dialog.value) : 0;
  } else if (dialog.dataType === "Bool") {
    dialog.value = dialog.value === "true";
  } else if (dialog.dataType === "Date") {
    // pass
  } else if (dialog.dataType === "Time") {
    // pass
  } else if (dialog.dataType === "Timestamp") {
    // pass
  } else if (dialog.dataType === "String") {
    // pass
  } else if (
    dialog.dataType === "Temperature" ||
    dialog.dataType === "TemperatureDiff" ||
    dialog.dataType === "Duration"
  ) {
    // pass
  }

  dialog.name = null;
  dialog.prepared = true;

  return dialog;
};
